import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import App from './App';
import './index.css';
import './i18n';
import { initObservability } from './lib/observability';
import { initSentry } from './lib/sentry';

// PHI-safe Sentry — no-op if VITE_SENTRY_DSN not set.
// Biometric data (HRV/Recovery/Sleep/Cycle) is auto-redacted via beforeSend.
initSentry();
initObservability();

// v1 launch: all Pro features are FREE for everyone (no IAP yet). Mark Pro active
// so existing feature gates unlock. When IAP ships, this line is removed and the
// flag is driven by StoreKit purchases instead.
try { localStorage.setItem('omnisio_workout_subscription_active', 'true'); } catch { /* SSR/private mode */ }

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </BrowserRouter>
  </React.StrictMode>
);
